import { useMemo as p, useCallback as I } from "react";
import { c as a } from "../../index-226b8ea6.js";
import { getLastListWithOrder as y } from "./SavedList.helpers.es.js";
const b = (i) => {
  const {
    checkedIds: e = [],
    createItemOptions: d,
    disabledIds: n = [],
    enableFooterLoader: c = !1,
    fetchNextPage: l,
    hasNextPage: m,
    isLoading: u,
    lists: s,
    onToggleItem: o,
    pageSize: r,
    renderCreateItem: L,
    total: S
  } = i, g = p(() => y(s), [s]), v = r ? [...Array(r)].map(() => ({
    isPlaceholder: !0
  })) : [], h = I(
    (t) => e.includes(t.id) ? o(
      t,
      [...e].filter((f) => f != t.id)
    ) : o(t, [...e, t.id]),
    [e]
  );
  return {
    checkedIds: e,
    createItemOptions: d,
    disabledIds: n,
    enableFooterLoader: c,
    fetchNextPage: l,
    hasNextPage: m,
    isLoading: u,
    lastListWithOrder: g,
    lists: s,
    onToggleItem: h,
    pageSize: r,
    renderCreateItem: L,
    skeletonListItems: v,
    total: S
  };
}, [O, T] = a(), [M, N] = a({
  name: "SavedListStylesContext",
  errorMessage: `useSavedListStyles returned is 'undefined'. Seems you forgot to wrap the components in "<SavedList />" `
});
export {
  O as SavedListProvider,
  M as SavedListStylesProvider,
  b as useSavedList,
  T as useSavedListProvider,
  N as useSavedListStyle
};
//# sourceMappingURL=SavedList.context.es.js.map
